<div class="competency-card" *ngIf="competency" [attr.style]="'--competency-header-color: ' + headerColor | safestyle">
  <div class="competency-card__header">
    <div class="competency-card__header-top">
      <div class="competency-card__type">{{ competency.type }}</div>
      <div class="competency-card__header-actions" *ngIf="canAccept || canReject">
        <button
          type="button"
          class="btn btn-sm btn-round btn-success competency-card__action"
          *ngIf="canAccept"
          [disabled]="disabled"
          (click)="onApprove()">
          Accept
        </button>
        <button
          type="button"
          class="btn btn-sm btn-round btn-danger competency-card__action"
          *ngIf="canReject"
          [disabled]="disabled"
          (click)="onReject()">
          Reject
        </button>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-round btn-link text-white competency-card__action competency-card__action--delete"
        *ngIf="canDelete"
        [disabled]="disabled"
        (click)="onDelete()">
        <span class="pi pi-times competency-card__delete-icon"></span>
        <span class="competency-card__delete-text">Delete</span>
      </button>
    </div>
  </div>
  <div class="competency-card__body">
    <div class="d-flex align-items-center">
      <div
        class="competency-card__badge"
        [attr.style]="'--competency-badge-color: ' + (competency.name | competencyBadgeColor) | safestyle">
        {{ competency.name }}
      </div>
      <i
        *ngIf="shouldShowAtCtInfoTooltip"
        class="fa-solid fa-circle-info ml-2 text-muted"
        [ngbTooltip]="'Allows AT and CT work'"
        placement="top">
      </i>
    </div>
    <div class="competency-card__details">
      <div class="competency-card__detail" *ngIf="competency.oem">
        <span class="competency-card__label">OEM:</span>
        <span class="competency-card__value">{{ competency.oem }}</span>
      </div>
      <div class="competency-card__detail" *ngIf="competency.model">
        <span class="competency-card__label">Model:</span>
        <span class="competency-card__value-wrap">
          <span #modelValue
                class="competency-card__value competency-card__multi-value"
                [class.competency-card__multi-value--collapsed]="!isModelExpanded"
                [class.competency-card__multi-value--expanded]="isModelExpanded">{{ competency.model }}</span>
          <button *ngIf="isModelOverflowing || isModelExpanded"
                  type="button"
                  class="btn btn-link btn-sm p-0 competency-card__view-toggle"
                  (click)="toggleModel()">
            <i class="fas" [ngClass]="isModelExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            {{ isModelExpanded ? 'View Less' : 'View More' }}
          </button>
        </span>
      </div>
      <div class="competency-card__detail" *ngIf="competency.rating">
        <span class="competency-card__label">Rating:</span>
        <span class="competency-card__value-wrap">
          <span #ratingValue
                class="competency-card__value competency-card__multi-value"
                [class.competency-card__multi-value--collapsed]="!isRatingExpanded"
                [class.competency-card__multi-value--expanded]="isRatingExpanded">{{ competency.rating }}</span>
          <button *ngIf="isRatingOverflowing || isRatingExpanded"
                  type="button"
                  class="btn btn-link btn-sm p-0 competency-card__view-toggle"
                  (click)="toggleRating()">
            <i class="fas" [ngClass]="isRatingExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            {{ isRatingExpanded ? 'View Less' : 'View More' }}
          </button>
        </span>
      </div>
      <div class="competency-card__detail" *ngIf="evidenceState !== 'none'">
        <span class="competency-card__label">Document:</span>
        <ng-container *ngIf="documentFileName && canRequestEvidence; else defaultEvidenceBlock">
          <span class="competency-card__value-wrap">
            <a *ngIf="canRequestEvidence" href="#"
                class="competency-card__link competency-card__link--placeholder competency-card_evidence-request-available d-block"
                (click)="onRequestEvidence(); $event.preventDefault()">
              <i class="pi pi-file competency-card__link-icon"></i>
              {{ statusValue === 'EXPIRED' ? 'Request New Evidence' : 'Request Evidence' }}
            </a>
            <a href="#"
                class="competency-card__link d-block"
                (click)="onDocumentClick($event)">{{ documentFileName }}</a>
          </span>
        </ng-container>

        <ng-template #defaultEvidenceBlock>
          <ng-container [ngSwitch]="evidenceState">
            <a *ngSwitchCase="'document'" href="#" class="competency-card__link"
                (click)="onDocumentClick($event)">{{ documentFileName }}</a>

            <a *ngSwitchCase="'upload'" href="#"
                class="competency-card__link competency-card__link--upload-evidence"
                (click)="onUploadEvidence(); $event.preventDefault()">
              <i class="pi pi-upload competency-card__link-icon"></i> Upload Evidence
            </a>

            <span *ngSwitchCase="'requested'"
                  class="competency-card__link competency-card__link--placeholder competency-card_evidence-requested">
              <i class="pi pi-file competency-card__link-icon"></i> Evidence Requested
            </span>

            <a *ngSwitchCase="'request'" href="#"
                class="competency-card__link competency-card__link--placeholder competency-card_evidence-request-available"
                (click)="onRequestEvidence(); $event.preventDefault()">
              <i class="pi pi-file competency-card__link-icon"></i>
              {{ statusValue === 'EXPIRED' ? 'Request New Evidence' : 'Request Evidence' }}
            </a>
          </ng-container>
        </ng-template>
      </div>
      <div class="competency-card__detail" *ngIf="canSubmitNewEvidence">
        <span class="competency-card__label">Renew:</span>
        <a href="#"
            class="competency-card__link competency-card__link--upload-evidence"
            (click)="onUploadEvidence(); $event.preventDefault()">
          <i class="pi pi-upload competency-card__link-icon"></i> Submit New Evidence
        </a>
      </div>
    </div>
    <div class="competency-card__rejection" *ngIf="reason || rejectedBy">
      <div class="competency-card__detail" *ngIf="reason">
        <span class="competency-card__label">Reason for Rejection:</span>
        <span class="competency-card__rejection-text">{{ reason }}</span>
      </div>
      <div class="competency-card__rejected-by" *ngIf="rejectedBy">
        <span class="competency-card__label">Rejected by:</span>
        <span class="competency-card__rejection-text">{{ rejectedBy }}</span>
      </div>
      <div class="competency-card__detail" *ngIf="canResubmitEvidence">
        <span class="competency-card__label">Resubmit:</span>
        <a href="#"
            class="competency-card__link competency-card__link--upload-evidence"
            (click)="onUploadEvidence(); $event.preventDefault()">
          <i class="pi pi-upload competency-card__link-icon"></i> Submit New Evidence
        </a>
      </div>
    </div>
  </div>
  <div class="competency-card__footer" *ngIf="isUserCard" [ngClass]="statusClass">
    <span class="competency-card__status-text">
      {{ statusPrefix }}<ng-container *ngIf="expiryDate">: {{ expiryDate | date: 'MMM dd, y' }}</ng-container>
    </span>
  </div>
</div>
